<!--
    Styles
-->

<style>

    .ui-select svg {
        width: 16px;
        height: 16px;
    }

</style>



<!--
    Template
-->

<template>
    <div class="ui-date">
        <input
            class="i-box"
            type="text"
            :value="text"
            @keyup="input"
            @compositionend="input"
            placeholder="YYYY / MM"
        >
    </div>
</template>



<!--
    Scripts
-->

<script>


    const ym = date => `${date.getFullYear()} / ${date.getMonth() + 1}`;
    const numbers = {'０': 0, '１': 1, '２': 2, '３': 3, '４': 4, '５': 5, '６': 6, '７': 7, '８': 8, '９': 9};
    const normalize = str => str.replace(/[０-９]/g, n => numbers[n]);


    export default {

        props: [
            'value'
        ],

        data () {
            return {
                text: ''
            }
        },

        methods: {

            set (year, month) {
                const n = parseInt(month.replace(/\D/g, ''));
                month = isNaN(n) ? '' : Math.max(Math.min(n, 12), 1);
                this.text = `${year} / ${month}`;
                this.$emit('update', new Date(year, month - 1));
            },

            input (event) {
                /* eslint-disable no-cond-assign */

                const text = this.text = normalize(event.target.value);
                const deleting = ['Backspace', 'Delete'].includes(event.key);

                let m;

                if (m = text.match(/^(\d{4})(\s|\/)?$/)) this.text = `${m[1]} / `;

                else if (m = text.match(/^(\d{4})(\d{1,2})\/?$/)) this.text = `${m[1]} / ${m[2]}`;

                else if ((m = text.match(/^(\d{4})\s?\/?$/)) && deleting) this.text = m[1];

                else if (m = text.match(/^(\d{4}) \/ (.*)/)) this.set(m[1], m[2]);

                else {
                    const numbers = text.match(/\d{1,4}/);
                    const year = numbers ? numbers[0] : '';
                    this.text = year;
                }
            }

        },

        mounted () {
            const date = new Date(this.value);
            if (!isNaN(date.getTime())) {
                this.text = ym(date);
            }
        }

    }

</script>
